// src/App.js

import React from 'react';
import EmojiPage from './pages/EmojiPage';

function App() {
  return (
    <div className="App">
      <EmojiPage />
    </div>
  );
}

export default App;
